import styled from 'styled-components';

export const CareerCanvasStyles = {
  Container: styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
  `,
  BtnWrapper: styled.div`
    margin: 0 auto 20px;
  `,
  ImageWrapper: styled.div`
    padding-top: 25px;
  `,
};
